import React from 'react';
import { Card, Col, Row, Space, Statistic } from 'antd';
import { CarOutlined, EnvironmentOutlined, SwapOutlined } from '@ant-design/icons';

type AverageRouteMetricsProps = {
  avgLocPerRoute: number;
  avgDisPerRoute: number;
  avgDisBetweenLocs: number;
};

const AverageRouteMetrics = ({
  avgLocPerRoute,
  avgDisPerRoute,
  avgDisBetweenLocs,
}: AverageRouteMetricsProps): JSX.Element => {
  const items = [
    {
      key: 'avgLocPerRoute',
      icon: <EnvironmentOutlined className="c-blue" />,
      label: 'Avg Location per Route',
      value: avgLocPerRoute.toFixed(0),
      suffix: '',
    },
    {
      key: 'avgDisPerRoute',
      icon: <CarOutlined className="c-green" />,
      label: 'Avg Distance per Route',
      value: avgDisPerRoute.toFixed(2),
      suffix: avgDisPerRoute ? 'Km' : '',
    },
    {
      key: 'avgDisBetweenLocs',
      icon: <SwapOutlined className="c-orange" />,
      label: 'Avg Distance between Locations',
      value: avgDisBetweenLocs.toFixed(2),
      suffix: avgDisBetweenLocs ? 'Km' : '',
    },
  ];

  return (
    <Col span={24} className="pd-half-rem">
      <Card className="modern-card w-100" title="Average Route and Location Metrics" bodyStyle={{ padding: '1.5rem' }}>
        <Row gutter={[24, 24]} justify="space-around" align="middle">
          {items.map(({ key, icon, label, value, suffix }) => (
            <Col xs={24} sm={12} md={8} key={key}>
              <Statistic
                title={
                  <Space>
                    {icon}
                    {label}
                  </Space>
                }
                value={value}
                suffix={suffix}
              />
            </Col>
          ))}
        </Row>
      </Card>
    </Col>
  );
};

export default AverageRouteMetrics;
